import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function RoundTableIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="6" cy="6" r="2" fill={props.fill} stroke={props.fill} strokeWidth="2" />
			<circle cx="18" cy="6" r="2" fill={props.fill} stroke={props.fill} strokeWidth="2" />
			<circle cx="6" cy="18" r="3" fill={props.fill} />
			<circle cx="18" cy="18" r="2" fill={props.fill} stroke={props.fill} strokeWidth="2" />
			<path opacity="0.5" d="M6 6V17" stroke={props.fill} strokeWidth="2" />
			<path opacity="0.5" d="M6 18L18 18" stroke={props.fill} strokeWidth="2" />
			<path opacity="0.5" d="M7 6L17 6" stroke={props.fill} strokeWidth="2" />
			<path opacity="0.5" d="M18 8.22217V15.6296" stroke={props.fill} strokeWidth="2" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<RoundTableIcon fill={props.fill} />
		</div>
	);
}